import { Module } from 'vuex';
import { IRootState, client } from '@/store';
import { IProject, IPageParams, ICRUDResponse } from '@/models';

export interface IProjectState {
  entities: Record<string, IProject>;
  currentPage: number[];
  pageParams: Partial<IPageParams>;
}

export const project: Module<IProjectState, IRootState> = {
  namespaced: true,
  state: {
    entities: {},
    currentPage: [],
    pageParams: {
      per_page: 15,
    },
  },
  actions: {
    getEntities({ commit }) {
      client
        .get<ICRUDResponse<IProject[]>>('project')
        .then(({ data: { data, ...pageParams } }) => {
          commit('setEntities', data);
          commit('setPageParams', pageParams);
        });
    },
    findEntity({ commit }, searchString) {
      return client
        .get<ICRUDResponse<IProject>>('project', {
          params: { name: searchString },
        });
    },
    getEntity({ commit }, id) {
      client
        .get<ICRUDResponse<IProject>>(`project/${id}`)
        .then(({ data: { data, ...pageParams } }) => {
          commit('setEntities', data);
          commit('setPageParams', pageParams);
        });
    },
    createEntity({ dispatch, rootState }, entity: Omit<IProject, 'id'>) {
      const id = (rootState as any).user.currentUser.id;
      return client
        .post('project', {
          ...entity,
          creator_id: id,
          responsible_id: id,
          project_labor_types: entity.project_labor_types,
        })
        .then(() => dispatch('getEntities'));
    },
    deleteEntity({ dispatch }, entity: IProject) {
      return client
        .delete(`project/${entity.id}`)
        .then(() => dispatch('getEntities'));
    },
    updateEntity({ dispatch }, entity: IProject) {
      return client
        .put(`project/${entity.id}`, entity)
        .then(() => dispatch('getEntities'));
    },
  },
  mutations: {
    setEntities(state, entities: IProject[]) {
      if (entities) {
        state.entities = entities.reduce(
          (acc, item) => ({ ...acc, [item.id]: item }),
          {},
        );
        state.currentPage = entities.map((entity) => entity.id);
      }
    },
    setPageParams(state, pageParams: Omit<ICRUDResponse<IProject[]>, 'data'>) {
      state.pageParams = pageParams;
    },
  },
  getters: {
    entitiesSlice({ currentPage, entities }) {
      return currentPage.map((id) => entities[id]);
    },
  },
};
